import { Inject, NgModule, Optional, PLATFORM_ID, TransferState, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterModule, Routes } from '@angular/router';

import { AuthGuard } from './core/guard/auth.guard';

import { LayoutComponent } from './layout/layout.component';
import { HomeComponent } from './components/home/home.component';
import { CartComponent } from './components/cart/cart.component';
import { QuickOrderComponent } from './components/quick-order/quick-order.component';
import { BlogComponent } from './components/blog/blog.component';
import { ThankYouComponent } from './components/thank-you/thank-you.component';
import { AccountGuard } from './core/guard/account.guard';
import { IngredientComponent } from './components/ingredient/ingredient.component';
import { BlogService } from './shared/services/blog.service';
import { HomeConfigurationService } from './shared/services/homeconfiguration.service';
import { AuthService, COOKIES, DEFAULT_VERSION, IS_ACCOUNT_ACTIVE, IS_AUTHENTICATED, REFRESH_TOKEN, TOKEN, CURRENT_VERSION, LATEST_VERSION, USERNAME } from './shared/services/auth.service';
import { isPlatformServer } from '@angular/common';
import { REQUEST } from '@/express.tokens';
import { CommonService } from './shared/services/common.service';
import { jwtDecode } from 'jwt-decode';
// import { WheelComponent } from './components/wheel/wheel.component';
import { NotificationComponent } from './components/notification/notification.component';
import { ProductLookupComponent } from './landing-pages/product-lookup/product-lookup.component';
import { BlogPromoComponent } from "@/app/components/blog/blog-promo/blog-promo.component";
import { BlogLegalAdviceComponent } from "@/app/components/blog/blog-legal-advice/blog-legal-advice.component";
import { GiftListComponent } from './shared/widgets/gift/gift-list/gift-list.component';
import { WelcomeBackComponent } from './landing-pages/welcome-back/welcome-back.component';
import { FaqComponent } from './components/blog/faq/faq.component';
import { WelcomeNewCustomerComponent } from './landing-pages/welcome-new-customer/welcome-new-customer.component';
import { LandingPageGuard } from './core/guard/landing-page.guard';
import { StatisticComponent } from './components/statistic/statistic.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: '',
    pathMatch: 'full'
  },
  {
    path: 'chao-mung-tro-lai-dvmedking',
    component: WelcomeBackComponent
  },
  {
    path: 'dang-ky-mua-hang',
    component: WelcomeNewCustomerComponent,
    canActivate: [LandingPageGuard]
  },
  {
    path: '',
    loadComponent: () => import("@/app/layout/layout.component").then(m => m.LayoutComponent),
    // resolve: {
    //   seoConfig: () => inject(HomeConfigurationService).getHomeConfigInfo(),
    // },
    children: [
      {
        path: '',
        loadComponent: () => import("@/app/components/home/home.component").then(m => m.HomeComponent),
        // resolve: {
        //   homeBanner: () => inject(HomeConfigurationService).getHomeBannerInfo(),
        //   venderBanner: () => inject(HomeConfigurationService).getVendorBannerInfo(),
        //   commentBanner: () => inject(HomeConfigurationService).getCommentBannerInfo(),
        //   flashSale: () => inject(FlashSaleService).getFlashSale(),
        // }
      },
      {
        path: 'product',
        loadChildren: () => import("@/app/components/product/product.module").then(m => m.ProductModule)
        // component: ProductComponent
      },
      {
        // Alias cũ của /product. Server trả 301 (server.ts); route này cho điều hướng phía client.
        path: 'san-pham',
        redirectTo: 'product'
      },
      // {
      //   path: 'product/:id',
      //   component: ProductDetailComponent,
      //   resolve: {
      //     product: (route: ActivatedRouteSnapshot) => inject(ProductService).getProductBySlug(route.params['id']).pipe(
      //       catchError(() => of(null))
      //     )
      //   }
      // },
      {
        path: 'ingredient',
        loadComponent: () => import("@/app/components/ingredient/ingredient.component").then(m => m.IngredientComponent)
      },

      {
        path: 'cart',
        loadComponent: () => import("@/app/components/cart/cart.component").then(m => m.CartComponent)
      },
      {
        path: 'quick-order',
        loadComponent: () => import("@/app/components/quick-order/quick-order.component").then(m => m.QuickOrderComponent),
        canActivate: [AuthGuard]
      },
      // {
      //   path: 'flash-sale',
      //   component: FlashSaleComponent,
      //   canActivate: [AuthGuard]
      // },
      {
        path: "auth",
        loadChildren: () => import("@/app/components/auth/auth.module").then(m => m.AuthModule)
      },
      {
        path: "account",
        loadChildren: () => import("@/app/components/account/account.module").then(m => m.AccountModule),
        canActivate: [AccountGuard],
        canActivateChild: [AccountGuard]
      },
      {
        path: "blog",
        loadChildren: () => import("@/app/components/blog/blog.module").then(m => m.BlogModule)
        // component: BlogListComponent,
      },
      {
        path: 'thank-you',
        loadComponent: () => import("@/app/components/thank-you/thank-you.component").then(m => m.ThankYouComponent)
      },
      // {
      //   path: 'wheel',
      //   component: WheelComponent,
      //   canActivate: [AuthGuard]
      // },
      {
        path: 'notification',
        loadComponent: () => import("@/app/components/notification/notification.component").then(m => m.NotificationComponent),
      },
      {
        path: 'campaign',
        loadChildren: () => import("@/app/components/campaign/campaign.module").then(m => m.CampaignModule)
      },
      {
        path: 'promo',
        redirectTo: 'campaign',
        pathMatch: 'full'
      },
      // {
      //   path: 'statistic',
      //   component: StatisticComponent,
      // },
      {
        path: 'legal-advice',
        loadComponent: () => import("@/app/components/blog/blog-legal-advice/blog-legal-advice.component").then(m => m.BlogLegalAdviceComponent)
      },
      {
        path: 'faq',
        loadComponent: () => import("@/app/components/blog/faq/faq.component").then(m => m.FaqComponent)
      },
      // {
      //   path: 'gift-list',
      //   component: GiftListComponent,
      //   canActivate: [AccountGuard],
      //   canActivateChild: [AccountGuard]
      // },
      {
        path: ':slug',
        loadComponent: () => import("@/app/components/blog/blog.component").then(m => m.BlogComponent),
        // resolve: {
        //   blog: (route: ActivatedRouteSnapshot) => inject(BlogService).getBlogBySlug(route.params['slug'])
        // }
      },
      {
        // URL không khớp route nào: hiển thị trang 404 tại chính URL đó (server trả HTTP 404), không redirect.
        path: '**',
        loadComponent: () => import("@/app/components/page/error404/error404.component").then(m => m.Error404Component)
      }
    ],
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      initialNavigation: 'enabledBlocking',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    @Optional() @Inject(REQUEST) private request: any,
    private transferState: TransferState,
    private commonService: CommonService,
    private authService: AuthService,
    private router: Router
  ) {
    if (isPlatformServer(this.platformId)) {
      this.request.cookies = this.request?.headers?.cookie;
      this.transferState.set(COOKIES, this.request?.cookies);

      const isAuthenticated = this.commonService.getCookie(this.request.cookies, 'token') ? true : false;
      this.transferState.set(IS_AUTHENTICATED, isAuthenticated);

      const token = this.commonService.getCookie(this.request.cookies, 'token');
      this.transferState.set(TOKEN, token);

      const refreshToken = this.commonService.getCookie(this.request.cookies, 'refreshToken');
      this.transferState.set(REFRESH_TOKEN, refreshToken);

      const currentVersion = this.commonService.getCookie(this.request.cookies, 'currentVersion');
      this.transferState.set(CURRENT_VERSION, currentVersion);

      const username = this.commonService.getCookie(this.request.cookies, 'username');
      this.transferState.set(USERNAME, username);

      if (isAuthenticated) {
        // Cookie token hỏng/không phải JWT: không được làm hỏng bootstrap SSR.
        try {
          const jwt = jwtDecode(token) as any;
          const isAccountActivated = jwt.Status === 'Active';
          this.transferState.set(IS_ACCOUNT_ACTIVE, isAccountActivated);
        } catch {
          this.transferState.set(IS_ACCOUNT_ACTIVE, false);
        }
      }

      const latestVersion = '2.0.0';

      // this.authService.getLatestVersion().subscribe({
      //   next: (latestVersion: any) => {
      this.transferState.set(LATEST_VERSION, latestVersion);

      if (currentVersion !== latestVersion) {
        // this.authService.logout();
        // this.router.navigate(['/auth/login']);

        this.transferState.set(CURRENT_VERSION, latestVersion);
        // console.log('Version not up to date');
      }
      //   },
      //   error: (error) => {
      //     console.log(error);
      //     this.authService.setCookie('currentVersion', DEFAULT_VERSION);
      //     this.transferState.set(CURRENT_VERSION, DEFAULT_VERSION);
      //   }
      // });
    }
    else {
      const currentVersion = this.transferState.get(CURRENT_VERSION, DEFAULT_VERSION);
      const latestVersion = this.transferState.get(LATEST_VERSION, DEFAULT_VERSION);
      if (currentVersion != latestVersion) {
        this.transferState.set(CURRENT_VERSION, latestVersion);
        //window.location.reload();
      }
      this.authService.setCookie('currentVersion', latestVersion);
    }
  }
}
